import { Good } from '../../../utils/common/NamingTerms';
import { INS_BASE_REST_URL } from '../../../utils/URL';

class CheckNetworkConnection {
    constructor() {
        this.state = {
            payload: null,
            abortController: new AbortController(),
            networkQuality: 'unknown',
        };
    }

    //checkNetwork
    checkNetwork() {
        const { payload, abortController, networkQuality } = this.state;
        if (payload === null && networkQuality !== Good) {
            if (
                alert(
                    'Your network signal is poor, try switching to another network, or do you wish to retry?'
                )
            ) {
                if (abortController) abortController.abort();
                const checkFunc =
                    this.browser === 'firefox' || this.browser === 'safari'
                        ? this.checkfirefoxNetworkSignal
                        : this.checkNetworkSignal;
                checkFunc.call(this); // Ensure correct context
            }
        }
    }

    //checkNetworkSignal
    async checkNetworkSignal() {
        try {
            this.state.payload = null;
            const connection =
                navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            if (connection) {
                const networkQuality = connection.effectiveType;
                if (networkQuality.includes('2g') || networkQuality.includes('slow-2g')) {
                    this.state.networkQuality = 'poor';
                    this.checkNetwork();
                } else {
                    this.state.networkQuality = 'good';
                }
            } else {
                this.state.networkQuality = 'unknown';
            }
            return true;
        } catch (error) {
            console.log('Network test failed', error);
            return false;
        }
    }

    //checkfirefoxNetworkSignal
    async checkfirefoxNetworkSignal() {
        try {
            this.state.payload = null;
            // Start measuring RTT
            const startTime = performance.now();
            const response = await fetch(`${INS_BASE_REST_URL}/ping`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Method': 'cookie',
                },
            });
            // Calculate RTT
            const endTime = performance.now();
            const rtt = endTime - startTime;
            if (response.ok) {
                if (rtt > 500) {
                    this.state.networkQuality = 'poor';
                    setTimeout(this.checkNetwork.bind(this), this.timeOut);
                } else {
                    this.state.networkQuality = 'good';
                }
            } else {
                this.state.networkQuality = 'unknown';
            }
            return true;
        } catch (error) {
            console.log('Network test failed', error);
            this.state.networkQuality = 'unknown';
            return false;
        }
    }
}

export default CheckNetworkConnection;
